import { Component, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbThemeService, NbDialogService, NbDialogRef } from '@nebular/theme';


import { LocalDataSource } from 'ng2-smart-table';


import { SmartTableService } from '../../../@core/data/smart-table.service';
import { ProduitService } from '../../../@core/data/rest/produit/produit-service';
import { Produit } from '../../../@core/data/model/produit';
import { BordereauService } from '../../../@core/data/rest/bordereau/bordereau-service';
import { Bordereau } from '../../../@core/data/model/bordereau';
import {FluxStockFormComponent} from '../../facture/fluxstockform/fluxstockform.component';

import {plainToClass} from 'class-transformer';
import {NgbDateStruct,  NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { SharedMethods } from '../../../util/sharedMethods-service';
import { isDefined } from '@ng-bootstrap/ng-bootstrap/util/util';
import { FluxStock } from '../../../@core/data/model/fluxstock';
import { FluxStockService } from '../../../@core/data/rest/fluxstock/fluxstock-service';
import { Reglement } from '../../../@core/data/model/reglement';
import { Validator } from '../../../@core/data/model/validator';
import swal from 'sweetalert2';

import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../../auth/auth.service';
import { Commande } from '../../../@core/data/model/commande';



@Component({
  // tslint:disable-next-line:component-selector
  selector: 'nb-bordereaueditmodalform',
  templateUrl: './editbordereauform.modal.component.html' ,
  styleUrls: ['./editbordereauform.modal.component.scss'],
})
export class EditFormModalBordereauComponent implements OnDestroy {


  @Input() name;
  @Input() bordereau: Bordereau;
  @Input() typeSaisir: string;
  @Input() closeAfterSave: boolean;
  @Input() fluxstock: FluxStock[];

  modalRef: NgbModalRef;

  private alive = true;

  data: Produit[];

  validate = false;

  produitloading: boolean;
  fluxstockedit: FluxStock;

  dialogIsNotShow = false;

  copy_bordereau: Bordereau;

  settings: any;

  source: LocalDataSource = new LocalDataSource();

  qteLivrer = 0;

  constructor(
    public produitService: ProduitService,
    public bordereauService: BordereauService,
    private route: ActivatedRoute,
    private router: Router,
    public sharedMethods: SharedMethods,
    private dialogService: NbDialogService,
    public fluxstockService: FluxStockService,
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    public authService: AuthService,
    protected dialogRef: NbDialogRef<FluxStockFormComponent>) {



  }




  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit() {

    this.authService.logoutEvent.subscribe(() => {

      this.close();

    });

    this.settings = {

      actions: {
        columnTitle: '',
        position: 'left',
        add: !this.bordereau.id,
        delete: !this.bordereau.id,
        edit: false, // on bloque l'édition pour faciliter ( obliger l'utilisateur à supprimer le flux pour le recréer ensuite avec une nouvelle valeur) la gestion des valeurs maximal de flux à saisir ( quantite qui depend de la quantité commandé et livré pour les retours )
      },
      add: {
        addButtonContent: '<i class="nb-plus"></i>',
        createButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
        confirmCreate: true,
      },
      edit: {
        editButtonContent: '<i class="nb-edit"></i>',
        saveButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
        confirmSave: true,
      },
      delete: {
        deleteButtonContent: '<i class="nb-trash"></i>',
        confirmDelete: true,
      },
      columns: {
        /* id: {
          title: 'ID',
          type: 'number',
          editable: false,
          addable: false,
          filter: false,
        }, */
        /* formatDateFlux: {
          title: 'Date',
          type: 'string',
          filter: false,
        }, */
        /* inventaire: {
          title: 'Inventaire',
          type: 'html',
          filter: false,
        }, */
        nomProduit: {
          title: 'Designation',
          type: 'string',
          filter: false,
        },
        quantite: {
          title: 'Qté',
          type: 'number',
          filter: false,
        },
        prix_unitaire: {
          title: 'PU',
          type: 'number',
          filter: false,
        },
        /*tva: {
          title: 'TVA',
          type: 'number',
          filter: false,
          show: false,
        },
        prixHT: {
          title: 'PHT',
          type: 'number',
          filter: false,
        },
        remise: {
          title: 'REM',
          type: 'number',
          filter: false,
        },*/
        prixTotal: {
          title: 'PT',
          type: 'number',
          filter: false,
        },
      },
      hideSubHeader: false,
      noDataMessage: 'Aucune opération effectuée',
      mode: 'external',
      pager: {
        display: false,
      },
    };

    // evenment de mise à jour du tableau des livraison
    this.source.onChanged().subscribe( (change) => {


      this.qteLivrer = this.bordereauService.quantiteLivrer(this.fluxstock);



    });

    // copie par valeur et non par référence afin que les modification sur la source ( facture)  ne se répercute pas sur la copie ( copy_facture) )
    this.copy_bordereau = plainToClass(Bordereau, Object.assign({}, this.bordereau) as object);

    this.init();

  }

  init() {

      if (this.fluxstock !== undefined && this.fluxstock !== null)
      this.source.load(plainToClass(FluxStock, this.fluxstock));
      // chargement produit
      if (this.produitService.produits === undefined) {
        this.getProduits();
      }

  }


  refreshCurrent() {

     this.dialogIsNotShow = true;
     this.bordereauService.getBordereau(this.bordereau.id).then ( bordereau => {

        this.fluxstock = bordereau.fluxstock;
        bordereau.fluxstock = [];

        this.bordereau = bordereau;
        this.init();
        this.dialogIsNotShow = false;

    });

  }

  getProduits() {

    this.produitService.getProduits().then( produits => {});

  }



  onDelete(event): void {

    /* if (window.confirm('Are you sure you want to delete?')) {

    } else {
      event.confirm.reject();
    } */
    // alert(JSON.stringify(event.data));

    if (!event.data.inventory) {

      this.source.remove(event.data);

      let itemIndex: number;

      if (event.data.id !== 0)
      itemIndex = this.fluxstock.findIndex(item => item.id === event.data.id);
      else
      itemIndex = this.bordereauService.indexCmdLivreByProd(event.data.produit.id, this.fluxstock);

      if (itemIndex > -1)
      this.fluxstock.splice(itemIndex, 1);

      /******************************************* Mise à jour emballage ******************************************/
      const itemIndexPr = this.produitService.produits.findIndex(item => item.id === event.data.produit.id);

      if ( itemIndexPr > -1) {

        const embal = this.produitService.produits[itemIndexPr].emballage;

        if (embal === null || embal === undefined )
        return;

        const FSEmball = this.bordereau.cmdLivreByProd(embal.id);

        if (FSEmball !== undefined) {

          // plus de besoin de mettre ajout dans le fluxstock car la variable actuelle pointe déjà vers là
          FSEmball.quantite = FSEmball.quantite - event.data.quantite;

          if (FSEmball.quantite <= 0) {
            const itemIndexEmball = this.bordereau.indexCmdLivreByProd(embal.id);
            this.fluxstock.splice(itemIndexEmball, 1);
          }

          this.source.load(plainToClass(FluxStock, this.fluxstock));

        }

      }

    } else {

      this.sharedMethods.toastShow('error', 'Opération non autorisé', 'Flux Déjà inventorié');

    }


    /* this.fluxstockedit = event.data;


    this.fluxstockService.deleteFluxstock(this.fluxstockedit).then( () => {

      this.source.remove(event.data);

      this.dialogIsNotShow = true;

      this.factureService.getFacture(this.facture.id).then( facture => {
          this.facture = facture;
          this.dialogIsNotShow = false;
          // alert(JSON.stringify(this.fluxstockedit));
      });

    }); */

  }


  onCreate(event): void {

    /*
      let user  = new User();
      user.FirstName = event.newData.FirstName;
      user.LastName = event.newData.LastName;
      user.Username = event.newData.Username;
      user.Email = event.newData.Email;
      user.Age = event.newData.Age;
      user.Activated = event.newData.Activated;
    */
   this.fluxstockedit = new FluxStock();

   this.fluxstockedit.bordereau = this.bordereau;
   this.fluxstockedit.type_flux = this.bordereau.type_bordereau;
   /* this.fluxstockedit.date_flux = this.facture.date_facturation;
   this.fluxstockedit.livrer = this.facture.livrer; */
   // this.fluxstockedit.nature_stock = this.natureStock;


    this.editFluxstock( this.fluxstockedit, 'add', this.typeSaisir, false);

  }


  onSave(event): void {

    if (!event.data.inventory) {

      this.fluxstockedit = event.data;
      this.fluxstockedit.bordereau = this.bordereau;
      this.fluxstockedit.type_flux = this.bordereau.type_bordereau;
      // this.fluxstockedit.nature_stock = this.natureStock;
      // alert(JSON.stringify(this.fluxstockedit));
      this.editFluxstock( this.fluxstockedit, 'update', this.typeSaisir, false);

    } else {

      this.sharedMethods.toastShow('error', 'Opération non autorisé', 'Flux Déjà inventorié');

    }


  }


  editFluxstock(fluxstock: FluxStock, typeEdit: string, saisir: string, savetoapi: boolean) {

    // pr = this.produitService.produits;

    const closeOnBackdropClick = false;
    this.dialogService.open(FluxStockFormComponent, {
      closeOnBackdropClick,
      context: {
        fluxstockedit : this.fluxstockedit,
        saveToApi: savetoapi,
        typeSaisir: saisir,
      },
    }).onClose.subscribe(data => {

        if (data !== undefined) {

            if (typeEdit === 'update') {

              // this.editFS(data, saisir);

            }

            if (typeEdit === 'add') {

              this.addFS(data, saisir);

                // commande des emballages
                let emballage: Produit;

                const itemIndex = this.produitService.produits.findIndex(item => item.id === data.produit.id);
                emballage = plainToClass(Produit, this.produitService.produits[itemIndex].emballage as object);

                // console.log(this.produitService.produits[itemIndex]);

              if ( emballage !== null && emballage !== undefined) {

                  const cmdemballage = new FluxStock;

                  cmdemballage.produit = emballage;
                  cmdemballage.type_flux = data.type_flux;
                  cmdemballage.quantite = data.quantite;
                  cmdemballage.prix_unitaire = emballage.prix_detail;
                  // cd.tva = data.tva;

                  this.addFS(cmdemballage, saisir);

                }


            }


        }

    });


  }


  editFS(data: any, saisir: string) {

      this.source.update(this.fluxstockedit, data);

      const itemIndex = this.fluxstock.findIndex(item => item.id === data.id);
      this.fluxstock[itemIndex] = plainToClass(FluxStock, data as object);
      // tslint:disable-next-line:no-console
      // console.log (this.facture.fluxstock[itemIndex]);

  }

  addFS(data: any, saisir: string) {

    const newFS =  plainToClass(FluxStock, data as object);


      const fsfind = this.bordereauService.cmdLivreByProd( newFS.produit.id, this.fluxstock );

      if ( fsfind !== undefined) {

        // cette operation met déjà a jour le flux dans la facture donc plus besoin de metre à jour la commande après
        fsfind.quantite += newFS.quantite;
        this.source.load(plainToClass(FluxStock, this.fluxstock));

      } else {

        this.source.append(data);

        if (this.fluxstock === undefined)
        this.fluxstock = [];

        this.fluxstock.push(plainToClass(FluxStock, data as object));

      }

  }


  printbordereau() {
    /* this.dialogIsNotShow = false;
    this.modalRef = this.modalService.open(PrintFormModalComponent, { centered: true, backdrop: 'static',  size: 'lg', windowClass: 'print-modal-xxl' });
    this.modalRef.componentInstance.id = this.facture.id; */
    this.captureScreenBordereau();
  }


  saveBordereau(validate: boolean): void {

    // alert(JSON.stringify(this.datefacture.date));
    // this.facture.date_facturation = this.sharedMethods.converNgbDateStructToString(this.datefacture);
    // this.facture.date_echeance = this.sharedMethods.converNgbDateStructToString(this.echeanceFacture);

    // on se raasure que le service n'est pas entrain d'effectuer une autre opération
    if (!this.bordereauService.iSsaving) {

      let valid: Validator;

      valid = this.sharedMethods.validateBordereau (this.bordereau, this.fluxstock);

      if (valid.result) {

        // alert(JSON.stringify(this.sharedMethods.converStringToDatetime(this.facture.date_facturation)));

        this.dialogIsNotShow = true;

        // fac.fluxstock = fluxstock;



        this.bordereauService.saveBordereauAndFlux(this.bordereau, this.fluxstock, validate).then( bordereau => {


          /* this.bordereauService.saveBordereauEvent.next({
            type: this.typeSaisir,
            bordereau: plainToClass(Bordereau, bordereau as object),
          }); */

          this.dialogRef.close(plainToClass(Bordereau, bordereau as object));


          /* this.dialogIsNotShow = false;
          this.bordereau.id = bordereau.id;
          this.bordereau.refgene = bordereau.refgene;
          this.bordereau.date_livraison = bordereau.date_livraison;
          this.bordereau.reffac = bordereau.reffac;
          this.bordereau.datefac = bordereau.datefac;
          // copie par valeur et non par référence afin que les modification sur la source ( facture)  ne se répercute pas sur la copie ( copy_facture) )
          this.copy_bordereau = plainToClass(Bordereau, Object.assign({}, this.bordereau) as object);

          // tslint:disable-next-line:no-console
          // console.log(this.bordereau);

          // this.ngOnInit();


          // this.sharedMethods.sweetalert('success', 'Facture Enregistré', '');
          let sujet = 'Bordereau  Enregistré';

          if (this.typeSaisir === 'livraison')
          sujet = 'Livraison  Enregistrée';

          if (this.typeSaisir === 'retour')
          sujet = 'Retour  Enregistré';

          this.sharedMethods.toastShow('success',  sujet, '');

          if (this.closeAfterSave)
          this.close(); */



        });

        /* this.factureService.saveFactureAndFlux(this.facture, this.facture.type_facture).then( facture => {

          this.dialogIsNotShow = false;

        }); */


      } else {

          this.sharedMethods.toastShow('error', valid.title, valid.message);

      }


    }


  }


  close() {

    /* if (!this.bordereauService.iSsaving) {

      // this.activeModal.dismiss(this.copy_bordereau);
      this.copy_bordereau.facture = null;
      this.dialogRef.close(this.copy_bordereau);

    } */

    this.dialogRef.close();
  }


  ngOnDestroy() {

    // clearInterval(this.intervalId);
    this.alive = false;
    // this.settingService.getCurrentDay();
    // alert('');
    /* if (this.modalRef !== undefined)
    this.modalRef.close(); */

    swal.close();

  }

  captureScreenBordereau() {

      const data = document.getElementById('contentConvert');

      const printContents = document.getElementById('contentConvert').innerHTML;
      const wLeft = window.screenLeft ? window.screenLeft : window.screenX;
      const wTop = window.screenTop ? window.screenTop : window.screenY;

      const left = wLeft + (window.innerWidth / 2) - (1000 / 2);
      const top = wTop + (window.innerHeight / 2) - (1000 / 2);

      // const popupWin = window.open('', '_blank', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width=1000, height=1000, top=' + top + ', left=' + left);
      const popupWin = window.open('', '_blank', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no, width=' + screen.width + ', height=' + screen.height + ', top=0, left=0');
      popupWin.focus();
      popupWin.document.open();
      const styleIsprintClass = '<style>.isprint{ display: block; } </style>';
      popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="assets/style/invoice.css" /> ' + styleIsprintClass + '</head><body onload="window.print()">' + printContents + '</body></html>');
      popupWin.document.close();
      // popupWin.close();

      /*const doc = new jspdf();

      doc.fromHTML(data, 15, 15, {
          'width': 170,
              'elementHandlers': specialElementHandlers
      });
      doc.save('sample-file.pdf'); */

      /* html2canvas(data).then(canvas => {
        // Few necessary setting options
        const imgWidth = 210; // with d'un format A4 (21cm * 29,7cm) les dimensions sont en mm ( paramètre du constructeur new jspdf())
        const pageHeight = 297;
        const imgHeight = canvas.height * imgWidth / canvas.width;
        const heightLeft = imgHeight;

        const contentDataURL = canvas.toDataURL('image/png');
      // new JsPDF(
            // Orientation, // l (Landscape) or p (Portrait)
            // unit, // mm, cm, in
            // format // A2, A4 etc
        // );
        const pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF
        const position = 10;
        pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
        pdf.save('MYPdf.pdf'); // Generated PDF

      }); */

  }


}
